import { Component, OnInit, Input, Output, EventEmitter,
  OnChanges, SimpleChanges, ViewChild, ElementRef, ViewContainerRef, ViewChildren, HostListener } from '@angular/core';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { MatDialog, MatCard } from '@angular/material';
import { DropFileComponent } from '../drop-file/drop-file.component';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';
import { FileUploadService } from '../../../../directives/file-drop/file-upload.service';
import { CachedFileService } from '../../../../directives/file-drop/cached-file-service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.css']
})
export class ImagePreviewComponent implements OnInit, OnChanges {
  fileInfo: IFileStoreItem = null;
  @ViewChild('preview', {static: false}) preview: ElementRef;  
  @ViewChild("previewwrapper", { static: false }) previewwrapper: ElementRef;
  @Input() caption: string = null;
  @Input() container: string = null;
  @Input() partition: string = null;
  @Input() fileId: string = null;
  @Input() variant: string = null;
  @Input() nomargin: boolean;
  @Input() isFlat = false;
  @Input() cached = false;
  @Input() previewHeight: number = null;
  @Input() previewWidth: number = null;
  @Input() widthProc: number = null;
  @Input() heightProc: number = null;
  @Input() height?: number = null;
  @Input() width?: number = null;    
  @Input() scaleHeight = false;
  @Input() scaleWidth = false;
  @Input() selected = false;
  @Input() selectedColor = 'red';
  @Input() selectedFontSize = '5px';
  @Input() captionFontSize = 'x-large';
  @Input() captionUpercase = true;
  @Input() showCaption = true;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onSelected = new EventEmitter<IFileStoreItem>();

  public loading = false;
  constructor(
    private fileService: FileUploadService,
    private fileCache:CachedFileService,
    private elRef: ElementRef,
    public dialog: MatDialog,
  ) {

  }
  ngOnChanges(changes: SimpleChanges) {
    const fileId = changes['fileId'];
    if (fileId) {
      const oldfileId = fileId.previousValue;
      const newfileId = fileId.currentValue;
      if (newfileId && oldfileId !== newfileId) {
        this.fileId = newfileId;
        this.onLoad();
      }
    }
  }
  @HostListener("window:resize", []) updatePreviewWidth() {    
    // lg (for laptops and desktops - screens equal to or greater than 1200px wide)
    // md (for small laptops - screens equal to or greater than 992px wide)
    // sm (for tablets - screens equal to or greater than 768px wide)
    // xs (for phones - screens less than 768px wide)

    if (window.innerWidth < 350) {
      this.captionFontSize = 'xx-small';//xs
    }
    else if (window.innerWidth < 500) {
      this.captionFontSize = 'smaller';//xs
    }    
    else if (window.innerWidth < 768) {
      this.captionFontSize = 'medium';//xs
    }
  }  

  ngOnInit() {
    this.updatePreviewWidth();
    this.onLoad();
  }
  onPreviewLoad() {    
    const elem = this.preview.nativeElement as HTMLImageElement;    
    const parent = this.elRef.nativeElement.parentElement as HTMLDivElement;
    const previewwrapper = this.previewwrapper.nativeElement as HTMLImageElement;

    if (elem) {
      const w = elem.width;
      const h = elem.height;
      const rhproc = w/h;
      const rwproc = h/w;
      if(this.widthProc){        
        const pwidth = parent.offsetWidth * this.widthProc / 100;
        const ch = h * rhproc / 100;
        this.previewWidth = pwidth;        
        elem.height = ch;
      }
      if(this.heightProc){        
        const pheight = parent.offsetHeight * this.heightProc / 100;
        const cw = h * rwproc / 100;
        this.previewHeight = pheight;
        elem.width =cw;
      }
      if(this.width){
        elem.width = this.width;
      }
      if(this.width){
        elem.width = this.width;
      }
      if(!this.height && !this.width){
        if (this.previewHeight) {
          const hproc = this.previewHeight * 100 / h;
          const cw = w * hproc / 100;
          elem.height = this.previewHeight;
          elem.width = cw;
        }
        if (this.previewWidth) {
          const wproc = this.previewWidth * 100 / w;
          const ch = h * wproc / 100;
          elem.height = ch;
          elem.width = this.previewWidth;
        }
        if(this.widthProc){
          let cw = parent.offsetWidth * this.widthProc / 100;
          const wproc = cw * 100 / w;          
          const ch = elem.height * wproc / 100;
          cw = elem.height * wproc / 100;
          elem.height = ch;
          elem.width = cw;
        }        
        if (elem.width > parent.offsetWidth) {
          const wproc = parent.offsetWidth * 100 / w;
          const ch = h * wproc / 100;
          elem.height = ch;
          elem.width = parent.offsetWidth;
        }
        if (elem.height > parent.offsetHeight) {
          const hproc = parent.offsetHeight * 100 / h;
          const cw = w * hproc / 100;
          elem.height = parent.offsetHeight;
          elem.width = cw;
        }
      }
      if(previewwrapper.offsetWidth<elem.width){
        const w = elem.width;
        const h = elem.height;        
        const wproc = previewwrapper.offsetWidth * 100 / w;
        const ch = h * wproc / 100;
        elem.width = previewwrapper.offsetWidth;
        elem.height = ch;        
      }
      if(previewwrapper.offsetHeight<elem.height){
        const w = elem.width;
        const h = elem.height;        
        const hproc = previewwrapper.offsetHeight * 100 / h;
        const cw = w * hproc / 100;
        elem.width = cw;
        elem.height = previewwrapper.offsetHeight;
      }      
    }
  }
  onLoad() {
    if (this.container && this.fileId) {
      this.onStartLoad();
      const file = <IFileInfo>{
        container: this.container,
        partition: this.partition,
        id: this.fileId,
        variant: this.variant
      };
      const observer:Observable<IFileStoreItem> = this.fileCache.Get(file);
      observer.subscribe((fileItem: IFileStoreItem) => {
        this.onEndtLoad();
        if (fileItem) {
          if(!this.fileCache.Exsists(file)){
            this.fileCache.Set(fileItem);
          }
          this.fileInfo = fileItem;
        }
      }, () => {
        this.onEndtLoad();
      });
    }
  }
  onSelectPreview() {
    this.onSelected.emit(this.fileInfo);
  }

  onStartLoad() {
    setTimeout(() => {
      this.loading = true;
    }, 0);
  }
  onEndtLoad() {
    setTimeout(() => {
      this.loading = false;
    }, 0);
  }
}
